export default {
  home: 'Главная',
  'newbie.greetings.message':
    'Впервые у нас? Давайте настроим ваш конструктор и поможем разобраться в нем',

  button: {
    'install.configure': 'Настроить и установить ваш конструктор',
    'tutorial.video': 'Смотреть обучающее видео',
    'show.orders': 'Посмотреть заказы',
    'installation.schedule': 'График монтажей'
  },

  orders: {
    new: 'Новых заказов',
    'in.progress': 'Заказов в работе'
  },

  caption: {
    'news.updates': 'Новые функции уже скоро',
    'constructor.notify': 'Уведомления'
  },

  pagination: {
    next: 'Далее',
    back: 'Назад',
    output: 'Выводить',
    all: 'Все',
    of: 'из'
  },

  commonMarkups: {
    part_price_wardrobe: 'Наценка на каркас и внутреннее наполнение шкафа',
    part_price_doors: 'Наценка на двери шкафа',
    waste_common: 'Запас на отход материала',
    shipping: 'Процент на доставку шкафа',
    assembly: 'Процент на сборку шкафа',

    notes: {
      part_price_wardrobe: `Процент наценки прибавляется к себестоимости деталей 
        каркаса и внутреннего наполнения шкафа`,
      part_price_doors: `Процент наценки прибавляется к себестоимости материалов 
        и комплектующих дверей шкафа`,
      waste_common: `Процент запаса на отходы по умолчанию прибавляется к количеству ЛДСП, ХДФ и кромки. 
        В настройках ниже вы можете установить индивидуальный процент запаса для любых типов материалов`,
      shipping: `Стоимость сборки шкафа рассчитывается как процент от 
        себестоимости всех деталей и элементов шкафа`,
      assembly: `Стоимость доставки шкафа рассчитывается как 
        процент от себестоимости всех деталей и элементов шкафа`
    }
  },

  statuses: {
    new: 'Новый',
    measurement: 'Ждет замер',
    contract: 'Договор',
    inproduction: 'В производстве',
    completed: 'Завершен'
  }
};
